import React from 'react';
import AppBar from '@mui/material/AppBar';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Add } from '@mui/icons-material';

import { membersType, useMembersContext } from '../../context';
import {
    ActionButton,
    AddMembers,
    AdminNavbar,
    Alert,
    headListType,
    OptimisedTable,
    ViewMembersTableData
} from '..';
import Container from '@mui/material/Container';

function a11yProps(index: number) {
    return {
        id: `view-members-tab-${index}`,
        'aria-controls': `view-members-tabpanel-${index}`
    };
}

export const MembersPage: React.FC = React.memo(() => {
    const { getMembers, getMembersResponse, adminMembers, employeeMembers } =
        useMembersContext();
    const [openAddMember, setAddMember] = React.useState(false);
    const [viewMember, setViewMember] = React.useState<0 | 1 | 2>(0);
    const [data, setData] = React.useState<membersType>(employeeMembers);

    const openAddMemberHandler = React.useCallback(
        () => setAddMember(true),
        []
    );
    const closeAddMemberHandler = React.useCallback(
        () => setAddMember(false),
        []
    );

    React.useEffect(() => {
        getMembers();
    }, [getMembers]);

    const headList: headListType = React.useMemo(
        () => [
            {
                property: 'Name'
            },
            {
                property: 'Email'
            },
            {
                property: 'Phone'
            },
            {
                property: 'Company'
            },
            {
                property: 'Active',
                CellProps: { padding: 'checkbox' }
            }
        ],
        []
    );
    const handleChange = React.useCallback(
        (_event: React.ChangeEvent<{}>, newValue: 0 | 1) => {
            setViewMember(newValue);
        },
        []
    );

    React.useEffect(
        () => setData(viewMember === 0 ? employeeMembers : adminMembers),
        [adminMembers, employeeMembers, viewMember]
    );

    return (
        <Container component='section' maxWidth='xl' sx={{ p: '6rem 0' }}>
            <Alert
                closeHandler={getMembersResponse.closeAlert}
                {...getMembersResponse.alert}
            />
            <AdminNavbar view />
            <OptimisedTable
                orderByInitial='Name'
                loading={getMembersResponse.loading}
                headList={headList}
                data={data}
                DataComponent={ViewMembersTableData}
                Tabs={
                    <AppBar position='static'>
                        <Tabs
                            value={viewMember}
                            onChange={handleChange}
                            aria-label='View Members Tab'
                            textColor='inherit'
                            indicatorColor='secondary'
                        >
                            <Tab label='Employees' {...a11yProps(0)} />
                            <Tab label='Admin' {...a11yProps(1)} />
                        </Tabs>
                    </AppBar>
                }
                removeDuplicates
                disableToolbar
                disableFilter
            />
            {viewMember === 0 ? (
                <AddMembers
                    memberRole='employee'
                    open={openAddMember}
                    closeHandler={closeAddMemberHandler}
                />
            ) : (
                <AddMembers
                    memberRole='admin'
                    open={openAddMember}
                    closeHandler={closeAddMemberHandler}
                />
            )}
            <FormControlLabel
                sx={{ marginTop: '1.5rem' }}
                control={
                    <ActionButton
                        Icon={<Add />}
                        sx={{ marginRight: '0.5rem' }}
                    />
                }
                onClick={openAddMemberHandler}
                label={`Add ${viewMember === 0 ? 'Employee' : 'Admin'}`}
            />
        </Container>
    );
});
